import React from "react";
import { Typography } from "@mui/material";
import "../Receipt.css";

const ReceiptHeader = ({ flightNumber, destination, dateTime }) => (
  <div className="header-wrap">
    <Typography className="invoice-header">
      Flight Number - {flightNumber}
    </Typography>
    <Typography className="invoice-header">
      Flight Destination - {destination}
    </Typography>
    <Typography className="invoice-header">{dateTime}</Typography>
  </div>
);

export default ReceiptHeader;
